import React from 'react';
import { Form } from 'react-bootstrap';

const DestinatarioSelect = ({
  destinatarios = [],
  value = '',
  onChange,
  size = 'sm',
  required = false,
  disabled = false,
  labelPadrao = 'Selecione...',
  ariaLabel = 'Selecione o destinatário',
  ...restProps
}) => (
  <Form.Select
    value={value}
    onChange={onChange}
    required={required}
    disabled={disabled}
    size={size}
    aria-label={ariaLabel}
    {...restProps}
  >
    <option value="">{labelPadrao}</option>
    {destinatarios.map((func, index) => {
      const id = func?.codFunc;
      const nome = func?.nome || 'SEM NOME';
      const itemKey = id ? String(id) : `func-${index}`;
      return (
        <option key={itemKey} value={id}>
          {nome.toUpperCase()} {id ? `(${id})` : ''}
        </option>
      );
    })}
  </Form.Select>
);

export default DestinatarioSelect;
